import { css } from '@emotion/react';
import styled from '@emotion/styled';
import React, { useRef } from 'react';
import { useButton } from 'react-aria';

import { su } from '../../theme/functions/su';
import { motion } from '../../theme/motion';
import { theme } from '../../theme/theme';

import { Glyph } from './Glyph';

export function Modus(props) {
  return <Modus.Root>{props.children}</Modus.Root>;
}

export function ModusButton(props) {
  const ref = useRef();
  const button = useButton(props);

  return (
    <ModusButton.Root {...button.buttonProps} ref={ref} isActive={props.isActive}>
      <ModusButton.Icon
        source={props.url}
        size={theme.icon.size_default}
        color={theme.color.icon_light}
      />
    </ModusButton.Root>
  );
}

Modus.Root = styled.div`
  display: flex;
  height: ${su(5)};
  align-items: center;
  margin-inline-start: ${su(4)};
  background: ${theme.color.component};
  box-shadow: ${theme.boxShadow.default};
  border-radius: ${theme.borderRadius.large};
  padding: ${su(0, 1)};
`;

ModusButton.Icon = styled(Glyph)`
  transition: ${motion.transition.micro};
`;

ModusButton.Root = styled.button`
  height: ${su(5)};
  width: ${su(5)};
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all ${motion.duration.fast} ${motion.curve.fast_in};

  &:hover {
    ${ModusButton.Icon} {
      color: var(--icon-color, ${theme.color.icon_light_hover});
      transform: scale(${theme.icon.scale_default});
    }
  }

  ${(props) =>
    props.isActive &&
    css`
      ${ModusButton.Icon} {
        --icon-color: ${theme.color.highlight};
        color: var(--icon-color);
      }
    `};
`;
